const modulePages = [
	{
		id: 'm4-page-1',
		isFacilitatorOnly: false,
		title: 'AT VÆRE AFSENDER',
		facilitatorText: null,
		groupText: `Vælg en person hver og læs dialogerne højt.`,
		icons: [],
		slides: [
			{
			type: 'video', 
			videoType: 'ignite',
			videoLink: 'https://kfs.euvideocdn.com/player/index.html?id=6a426047ac55558c8179456f',
			text: 'SE VIDEO',
			roles: ['facilitator']
		},
		{
			id: 'kommunikationstrekanten',
			type: 'image',
			text: 'KOMMUNIKATIONSTREKANTEN',
			roles: ['facilitator']
		},
		{
			id: 'm4-slide',
			type: 'image',
			text: 'SLIDE',
			roles: ['facilitator']
		},
		{
			id: 'm4-eksempel-1',
			type: 'image',
			text: 'EKSEMPEL 1',
			roles: ['facilitator', 'group']
		},
		{
			id: 'm4-eksempel-2',
			type: 'image',
			text: 'EKSEMPEL 2',
			roles: ['facilitator', 'group']
		},
		{
			id: 'm4-eksempel-3',
			type: 'image',
			text: 'EKSEMPEL 3',
			roles: ['facilitator', 'group']
		},
		{
			id: 'm4-eksempel-4',
			type: 'image',
			text: 'EKSEMPEL 4',
			roles: ['facilitator', 'group']
		},		
		{
			id: 'm4-eksempel-5',
			type: 'image',
			text: 'EKSEMPEL 5',
			roles: ['facilitator', 'group']
		},
		{
			id: 'm4-ovelse',
			type: 'image',
			text: 'ØVELSE'
			,
			roles: ['facilitator']
		},
	]	
	},
	{
		id: 'm4-page-2',
		isFacilitatorOnly: true,
		title: 'AT VÆRE MODTAGER',
		icons: [],
		slides: [
			{
				id: 'kommunikationstrekanten',
				type: 'image',
				text: 'KOMMUNIKATIONSTREKANTEN'
			},
			{
				id: 'm4-ovelse-2',
				type: 'image',
				text: 'ØVELSE'
			},	
			{
				id: 'm4-basalboxen',
				type: 'image',
				text: 'BASALBOXEN'
			}
		]	
	},
	{
		id: 'm4-page-3',
		isFacilitatorOnly: true,
		title: 'BASALPLAN',
		// facilitatorDownloads: [{
		// 	title: 'Følelsesmemory',
		// 	file: '0622_Basal_undervisningsvejledning_A4_memory.pdf'
		// }],
		facilitatorText: null,
		groupText: null,
		icons: [],
		slides: [
			{
				id: 'm4-case',
				type: 'image', 
				text: 'CASE'
			},
			{
				id: 'm4-ovelse-3',
				type: 'image',
				text: 'ØVELSE'
			},
			{
				type: 'video',
				videoType: 'youtube',
				videoId: 'P_JiU1GnAks',
				text: 'SE VIDEO',
				duration: 91
			}
		]
	}
];


export {
	modulePages
};